import { Grid, TextField } from "@material-ui/core";
import PopupForm from "app/common/Component/Popup/PopupForm";
import React, { useEffect, useRef } from "react";
import { observer } from "mobx-react";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import { useState } from "react";
import { getVisitByQRCode, pagingPatient } from "app/services/PatientService";
import { useHistory, useLocation } from "react-router-dom";
import {
    GEN_QR_TYPE,
    GEN_QR_TYPE_GLASSES,
    GEN_QR_TYPE_MEDICINE,
    PathForPatientInfor,
    PathModule
} from 'app/common/LocalConst';
import Config from 'app/appConfig';
import CommonButton from "../Button/CommonButton";
import { pagingPatientByCurrentUser } from "app/services/VisitService";
import { pagingPatientInvoice } from "app/services/InvoiceService";
import { pagingTreatingPatient } from "app/services/InpatientService";
import Popup from "../Popup/Popup";

export default observer(function ScanQRPopup({ open, handleClose }) {
    const scanQRImg = require('../../Image/scanQR.jpg');
    const qrCodeRef = useRef();
    const [isFocused, setIsFocused] = useState(false);
    const [formValues, setFormValues] = useState();
    const history = useHistory();
    const location = useLocation();

    const pathModuleName = location?.pathname?.split("/")?.length > 1 ? location?.pathname?.split("/")[1] : "";
    const redirectPatientInfor = (patientId) => {
        if (patientId?.length > 0 && patientId !== undefined && pathModuleName?.length > 0) {
            const pathPatientOfModule = PathForPatientInfor.find((item) => item?.name?.toLowerCase() === pathModuleName?.toLowerCase())?.value || PathForPatientInfor[0]?.value;
            if (pathPatientOfModule?.length > 0) {
                history.push(Config.ROOT_PATH + pathPatientOfModule + "?patientId=" + patientId);
            }
        }
    }

    const searchInit = {
        pageIndex: 1,
        pageSize: 10
    }

    const apiPagingPatient = (pathModuleName?.toLowerCase() === PathModule.PATIENT_RECEPTION_ROOM?.toLowerCase() ? pagingPatient :
        (pathModuleName?.toLowerCase() === PathModule.VISIT?.toLowerCase() ? pagingPatientByCurrentUser :
            (pathModuleName?.toLowerCase() === PathModule.FEE?.toLowerCase() ? pagingPatientInvoice :
                (pathModuleName?.toLowerCase() === PathModule.BOARDING?.toLowerCase() ? pagingTreatingPatient : pagingPatient))));

    useEffect(() => {
        //trường hợp là đơn kính hoặc các mã có type  (format mã BN|loại QR|id (đơn thuốc)/id visit(đơn kính))
        if (formValues?.length > 0) {
            let qrContentItems = formValues?.split("|");
            if (qrContentItems?.length > 1 && (pathModuleName?.toLowerCase() === PathModule.BOARDING?.toLowerCase() || pathModuleName?.toLowerCase() === PathModule.VISIT?.toLowerCase())) {
                let patientCode = qrContentItems[0];  //quét đơn thuốc và quét đơn kính đang ở module thăm khám và nội trú thì vào tab tương ứng, còn lại vào patientInfo
                let qrType = (Number(qrContentItems[1]));
                let descriptionId = qrContentItems[2] ? qrContentItems[2] : null; //id don  thuoc (neu co)
                const searchObj = { patientCode: patientCode, qrType: qrType, descriptionId: descriptionId }
                if (GEN_QR_TYPE?.find((item) => item?.value === qrType)) {
                    getVisitByQRCode(searchObj).then(({ data }) => {
                        if (data && data?.id && (data?.patientId || data?.patient?.id)) {
                            if (qrType === GEN_QR_TYPE_MEDICINE) {
                                history.push(Config.ROOT_PATH + PathModule.VISIT + "/eye-test?visitId=" + data?.id + "&patientId=" + (data?.patientId ? data?.patientId : data?.patient?.id) + "&isPrescription=true")
                            } else if (qrType === GEN_QR_TYPE_GLASSES) {
                                history.push(Config.ROOT_PATH + PathModule.VISIT + "/eye-test?visitId=" + data?.id + "&patientId=" + (data?.patientId ? data?.patientId : data?.patient?.id) + "&isVisualAcuityTest=true")
                            }
                            handleClose();
                        }
                    })
                }

            }
            else {
                let searchTextQR = formValues;
                if(qrContentItems?.length > 1){
                    searchTextQR = qrContentItems[0];
                }
                let searchObj = (pathModuleName?.toLowerCase() === PathModule.PATIENT_RECEPTION_ROOM?.toLowerCase() ? { ...searchInit, code: searchTextQR } : (
                    pathModuleName?.toLowerCase() === PathModule.VISIT?.toLowerCase() ? { ...searchInit, tab: 0, keyword: searchTextQR } : (
                        pathModuleName?.toLowerCase() === PathModule.FEE?.toLowerCase() ? { ...searchInit, tab: 0, code: searchTextQR } : (
                            pathModuleName?.toLowerCase() === PathModule.BOARDING?.toLowerCase() ? { ...searchInit, tab: 0, patientCode: searchTextQR } : { ...searchInit, tab: 0, code: searchTextQR }
                        )
                    )
                ))
                 
                setTimeout(() => {
                    apiPagingPatient(searchObj).then(({ data }) => {
                        if (data?.content?.length > 0 || data?.patientInvoiceContent?.length > 0) {
                            const item = data?.content?.[0] || data?.patientInvoiceContent?.[0]; 
                            if (pathModuleName?.toLowerCase() === PathModule.BOARDING?.toLowerCase() && item?.patient?.id?.length > 0) {
                                redirectPatientInfor(item?.patient?.id);
                                handleClose();
                            }
                            else if (item?.id?.length > 0 || item?.patientId?.length > 0) {
                                redirectPatientInfor(item?.id || item?.patientId);
                                handleClose();
                            }
                        }
                    })

                }, 500)
            }

        }
    }, [formValues])

    useEffect(() => {
        if (isFocused && qrCodeRef.current) {
            qrCodeRef.current.focus();
        }
    }, [isFocused]);

    useEffect(() => {
        setTimeout(() => {
            setIsFocused(true)
        }, 100)
    },[])
        
    const handleFocus = () => {
        qrCodeRef.current.focus();
    };

    return (
        <Popup
            size="xs"
            title="Quét mã QR"
            open={open}
            handleClose={handleClose}
           
            hideFooter
        >
            <>
                <Grid container spacing={1} style={{ textAlign: "center" }} justifyContent="center">
                    <Grid item xs={12}>
                        <img src={scanQRImg} width="250px" />
                    </Grid>
                    <Grid item xs={12}>
                        <strong>Mời quét QR trên giấy tờ được cung cấp</strong>
                    </Grid>
                    {formValues}
                    <Grid item xs={12}>
                        <TextField
                            placeholder= "Mã QR"
                            value={formValues}
                            onChange={(e) => {
                                setFormValues(e.target.value)
                            }}
                            className="input-container"
                            notDelay
                            fullWidth
                            ref={qrCodeRef}
                        />
                        
                    </Grid>
                    <Grid item xs={6}>
                        <CommonButton fullWidth onClick={() => {
                            handleFocus();
                            setFormValues("")
                        }}>
                            <strong className='ml-2'>Quét lại</strong>
                        </CommonButton>
                    </Grid>
                </Grid>
            </>
        </Popup>
    );
})
